import React, { useEffect, useState } from "react";
import Html5QrReader from "../common/Html5QrReader";
import Loader from "../common/Loader";

interface IParams {
  handleConnection: (code: string) => void;
}

export const QrReaderContainer: React.FC<IParams> = ({ handleConnection }) => {
  const [loading, setLoading] = useState(false);

  //serve a ri-renderizzare il lettore qr
  const handleOrientation = () => {
    setLoading(true);
    setLoading(false);
  };

  useEffect(() => {
    window.addEventListener("orientationchange", handleOrientation);

    return () => {
      window.removeEventListener("orientationchange", handleOrientation);
    };
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Html5QrReader onReadSuccess={handleConnection} />
      )}
    </>
  );
};
